var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBackToTop)?_c('div',{class:_vm.bem(),on:{"click":_vm.scrollToTop}},[_c('img',{attrs:{"src":require("../assets/images/back.png"),"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }